import { sortBy } from 'lodash';
import tube from './tube';
import foundation from './foundation';
import rms from './rms';
import ta from './ta';
import py from './py';


let links = [...tube, ...foundation, ...rms, ...ta, ...py];
links = sortBy(links, ['sort']);
export default links;



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/config/links/index.js
 **/